function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Box } from "../Box/index.js";
import { Typography } from "../Typography/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { color } from "../../utils/index.js";
export var APPEARANCES = {
  BUTTERCUP: 'buttercup',
  CRIMSON: 'crimson',
  FOREST: 'forest',
  GREY: 'grey',
  AQUA: 'aqua',
  OVERLAY: 'overlay'
};
export var TYPES = {
  FILLED: 'filled',
  TINT: 'tint'
};
function getAppearanceColor(type, appearance) {
  var appearancesDef = _defineProperty(_defineProperty({}, TYPES.TINT, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, APPEARANCES.BUTTERCUP, COLOR_VARIANTS.BUTTERCUP10), APPEARANCES.CRIMSON, COLOR_VARIANTS.CORAL10), APPEARANCES.FOREST, COLOR_VARIANTS.FOREST10), APPEARANCES.GREY, COLOR_VARIANTS.ALICE), APPEARANCES.AQUA, COLOR_VARIANTS.AQUA10)), TYPES.FILLED, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, APPEARANCES.BUTTERCUP, COLOR_VARIANTS.BUTTERCUP100), APPEARANCES.CRIMSON, COLOR_VARIANTS.CORAL100), APPEARANCES.FOREST, COLOR_VARIANTS.FOREST100), APPEARANCES.GREY, COLOR_VARIANTS.GREYCHATEAU), APPEARANCES.AQUA, COLOR_VARIANTS.AQUA100), APPEARANCES.OVERLAY, COLOR_VARIANTS.OVERLAY));
  return appearancesDef[type] && appearancesDef[type][appearance] ? appearancesDef[type][appearance] : appearancesDef[TYPES.TINT][APPEARANCES.BUTTERCUP];
}
export var Tag = function Tag(_ref) {
  var appearance = _ref.appearance,
    type = _ref.type,
    children = _ref.children,
    icon = _ref.icon,
    trailingIcon = _ref.trailingIcon,
    testId = _ref.testId,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    isFullWidget = _ref.isFullWidget;
  var appearanceColor = getAppearanceColor(type, appearance);
  return /*#__PURE__*/React.createElement(Box, {
    className: "__ds__comp ".concat(className),
    sx: {
      padding: '4px 8px',
      display: isFullWidget ? 'flex' : 'inline-flex',
      borderRadius: '4px',
      alignItems: 'center',
      background: color(appearanceColor)
    },
    "data-testid": testId,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(React.Fragment, null, icon && !trailingIcon && /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginRight: '5px',
      display: 'flex',
      alignItems: 'center'
    }
  }, icon), /*#__PURE__*/React.createElement(Typography, {
    variant: TYPOGRAPHY_VARIANT.CAPTIONSEMBLD,
    color: appearanceColor,
    colorType: "contrastText",
    component: "h3"
  }, children), icon && trailingIcon && /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginLeft: '5px',
      display: 'flex',
      alignItems: 'center'
    }
  }, icon)));
};